import { Component, OnInit } from "@angular/core";
import { FechasService } from "src/app/services/fechas/fechas";
import { FormGroup, FormControl } from "@angular/forms";
import { MessageService, SelectItem } from "primeng/api";
import { PitufoService } from "src/app/services/pesos/pitufo";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { StorageManager } from "src/app/common/storage-manager.class";
import { VariedadesService } from "src/app/services/variedades/variedades";
import { EmailService } from "src/app/services/email/emailService";
import { UploadService } from "src/app/services/upload/upload.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-pesos-create-update",
  templateUrl: "./pesosCreateUpdate.component.html",
  styleUrls: ["./pesosCreateUpdate.component.css"],
  providers: [FechasService, PitufoService, VariedadesService],
})
export class PesosCreateUpdateComponent implements OnInit {
  public items = {
    id: "",
    maquina: "",
    cliente: "",
    responsable: "",
    fecha: "",
    hora: "",
    variedad: "",
    pesos: "",
    pesos_horas: "",
    confecccion: "",
    id_etiqueta: "",
    observaciones: "",
    global_gap: false,
    IGP: false,
    prod_integrado: false,
    residuo: false,
  };
  public myId = "";
  public otropeso = "";
  public pesos: any[] = [];
  public pesos_horas: any[] = [];
  public myConfeccion: string = "";
  public id_etiqueta: string = "";
  public observaciones: string = "";
  public variedades: SelectItem[] = [];
  public selectedVariedad: any;
  public variedad = "";
  public myClient: string = "";
  public MyHour: string = "";
  public etiqueta_archivo: string = ''
  // public fecha: Date = new Date(this.fechasService.fechaActual());
  public fecha: Date;
  public MyWeight: string = "";
  public MyWeightHour: string = this.fechasService.hora();
  public MyMachine: string = "";
  public contador = 0;
  public pesosForm: FormGroup;
  public product: any = { fecha: "", nombre: "", hora: "", peso: "" };
  public es = {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Borrar",
  };
  public user: any;
  public myResponable: string = "";
  public baseUrl = environment.urlUpload;
  public url: string = this.baseUrl + "/pesos/pitufo/";
  public imgURL: any =
    "https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public id: any;
  public file: File;
  public message: string;
  public imagePath: any;
  public archivo = "";
  public disableButton = false;
  public global_gap: boolean = false;
  public IGP: boolean = false;
  public prod_integrado: boolean = false;
  public residuo: boolean = false;

  public update: boolean;
  public loaderSubmit: boolean = false;
  public title: string = '';
  public url1_redirect;
  public database: string = 'PesoPitufo'

  public urlTest: string = this.baseUrl + '/PesoPitufo/'


  constructor(
    private fechasService: FechasService,
    private messageService: MessageService,
    private pitufo: PitufoService,
    private location: Location,
    private route: ActivatedRoute,
    private variedadesService: VariedadesService,
    public router: Router,
    private emailService: EmailService,
    private UploadService: UploadService,

  ) {
    this.user = StorageManager.getUser();
  }

  ngOnInit() {
    this.myResponable = this.user.name;
    let id;
    this.variedades.push({ label: "Selecciona variedad", value: null });
    this.variedadesService
      .listVariedad()
      .toPromise()
      .then((data: any) => {
        for (let index = 0; index < data.length; index++) {
          const element = { label: data[index].nombre, value: data[index].id };
          this.variedades.push(element);
        }
      })
      .then(() => {
        this.route.params.subscribe((data: any) => {
          this.myId = data;

          if (Object.keys(data).length >= 1) {
            this.update = true;
            this.title = 'Editar registro control pesos'
            this.id = data.id;
            this.pitufo.getPesoPitufo(this.myId).subscribe(
              (resp: any) => {
                console.log(resp);

                let producto = resp.productos[0];

                this.myConfeccion = producto.confeccion;
                this.myClient = producto.cliente;
                this.fecha = new Date(producto.fecha);
                this.MyHour = producto.hora;

                this.MyMachine = producto.maquina;
                this.variedad = producto.variedad;
                this.id_etiqueta = producto.id_etiqueta;
                this.observaciones = producto.observaciones;
                this.myResponable = producto.responsable;
                this.global_gap = producto.global_gap;
                this.IGP = producto.IGP;
                this.prod_integrado = producto.prod_integrado;
                this.residuo = producto.residuo;

                let myPeso = producto.pesos.split(";");
                let myPesoHora = producto.pesos_horas.split(";");
                for (let index = 0; index < myPeso.length; index++) {
                  if (myPeso[index] == "") {
                  } else {
                    this.pesos.push({ peso: myPeso[index] });
                    this.pesos_horas.push({ hora: myPesoHora[index] });

                    this.pesos = [...this.pesos];
                    this.pesos_horas = [...this.pesos_horas];
                  }
                }
                for (let index = 0; index < this.pesos_horas.length; index++) {
                  this.pesos_horas[index] =
                    this.pesos_horas[index] == "UNDEFINED"
                      ? ""
                      : this.pesos_horas[index];
                }

                if (
                  resp.productos[0].etiqueta_archivo == null ||
                  resp.productos[0].etiqueta_archivo == undefined
                ) {
                } else {
                  this.url1_redirect = this.urlTest + resp.productos[0].etiqueta_archivo;
                }
              },
              (error) => {
                console.log("Error" + error);
              }
            );
          } else {
            this.update = false;
            this.title = 'Crear registro control pesos'
            this.MyHour = this.fechasService.hora();
            this.fecha = new Date(this.fechasService.fechaActual());
          }
        });
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }

  uploadFile(event) {

    this.message = ''
    this.imgURL = 'https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com'

    this.file = event.target.files[0];
    let files = event.target.files;
    let numb = this.file.name.lastIndexOf(".");
    if (files.length === 0) return;

    var mimeType: string = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.file = null
      this.message = "Only images are supported.";
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Las extensiones de las imágenes permitidias son jpg,jpeg,png",
      });
      return;
    }
    //console.log('mimeType', mimeType );
    if (mimeType.localeCompare("image/bmp") == 0) {
      this.file = null
      this.archivo = "";
      this.file = null;
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "Las extensiones de las imágenes permitidias son jpg,jpeg,png",
      });
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
    /* uploadFile(event){
    //console.log(event.target.files);
    //let file:File=event.target.files[0];
    this.file=event.target.files[0];
    console.log(event.target.files);
    let numb=this.file.name.lastIndexOf(".");
    let subExt=this.file.name.substring(numb);
    //console.log("ext ",subExt);



      } */
  }

  poner() {
    if (this.MyWeight == "") {
      this.messageService.add({
        severity: "error",
        summary: "Formulario no cumplimentado",
        detail: "El campo de peso tiene que contener algún valor",
      });
    } else {
      let myArray = new info(
        this.fecha,
        this.MyHour,
        this.MyMachine,
        this.MyWeight
      );

      this.pesos.push({ peso: myArray.peso });
      this.pesos_horas.push({ hora: this.MyWeightHour });
      this.pesos = [...this.pesos];
      this.pesos_horas = [...this.pesos_horas];
      this.MyWeight = "";
    }
    /*
    this.product.fecha=(this.fecha);
    this.product.nombre=this.MyMachine;
    this.product.peso=(this.MyWeight);
    this.product.hora=this.MyHour;
    */
    //this.items.push(this.product);

    //console.log(this.items);
  }

  hora() {
    let fecha = new Date();
    let hora = "" + fecha.getHours();
    let min = "" + fecha.getMinutes();
    if (fecha.getHours() < 10) {
      hora = "0" + hora;
    }

    if (fecha.getMinutes() < 10) {
      min = "0" + min;
    }
    let myHour = hora + ":" + min;

    return myHour;
  }

  enviar() {
    this.loaderSubmit = true;

    if (this.myClient == "" || this.myConfeccion == "" || this.variedad == "") {
      this.messageService.add({
        severity: "error",
        summary: "Formulario no cumplimentado",
        detail: "Los campos de cliente, confección y variedad son obligatorios",
      });
    } else {
      let nuevosPesos = "";
      let nuevosPesosHoras = "";
      //console.log("pesos",this.pesos[0]);
      for (let index = 0; index < this.pesos_horas.length; index++) {
        this.pesos_horas[index] =
          this.pesos_horas[index] == "UNDEFINED" ? "" : this.pesos_horas[index];
      }
      for (let index = 0; index < this.pesos.length; index++) {
        nuevosPesos = nuevosPesos + "" + this.pesos[index].peso + ";";
        nuevosPesosHoras =
          nuevosPesosHoras + "" + this.pesos_horas[index].hora + ";";
      }
      //console.log(nuevosPesos);
      let fechaFix = this.fechaArreglada(this.fecha);

      this.MyHour = this.MyHour.toString();
      this.MyHour =
        this.MyHour.length > 5 ? this.MyHour.substr(16, 5) : this.MyHour;

      this.items = {
        id: this.myId,
        maquina: this.MyMachine,
        cliente: this.myClient,
        responsable: this.myResponable,
        fecha: fechaFix,
        hora: this.MyHour,
        variedad: this.variedad,
        pesos: nuevosPesos,
        pesos_horas: nuevosPesosHoras,
        confecccion: this.myConfeccion,
        id_etiqueta: this.id_etiqueta,
        observaciones: this.observaciones,
        global_gap: this.global_gap,
        IGP: this.IGP,
        prod_integrado: this.prod_integrado,
        residuo: this.residuo,
      };

      /*

 $sql="SELECT `id`,`maquina`,`cliente`,`variedad`,`pesos`,`etiqueta_archivo`,`responsable`,`observaciones`,"
    ."date_format(`fecha`,'%d/%m/%Y') as `fecha` ,`global_gap`,`IGP`,`,`prod_integrado`,`residuo`"
    ."`hora`,`confeccion` FROM `PesoPitufo` ORDER BY PesoPitufo.fecha DESC;";


$global_gap = mb_strtoupper(mysqli_real_escape_string($conn,$data['global_gap']),"utf8");
$IGP = mb_strtoupper(mysqli_real_escape_string($conn,$data['IGP']),"utf8");
$prod_integrado = mb_strtoupper(mysqli_real_escape_string($conn,$data['prod_integrado']),"utf8");
$residuo = mb_strtoupper(mysqli_real_escape_string($conn,$data['residuo']),"utf8");

$sql="INSERT INTO `PesoPitufo`(`maquina`,`cliente`,"
        ."`variedad`,`pesos`,`fecha`,`hora`,`confeccion`,`id_etiqueta`,`observaciones`,`responsable`,`global_gap`,`IGP', `prod_integrado',`residuo')"
        ."VALUES ('$maquina','$cliente','$variedad','$pesos','$fecha','$hora','$confeccion','$id_etiqueta','$observaciones','$responsable','$global_gap','$IGP','$prod_integrado','$residuo');";

*/

      console.log(this.items);
      console.log(this.file)

      this.disableButton = true;
      if (this.update) {
        this.pitufo
          .updatePitufo(this.items)
          .toPromise()
          .then(
            (resp) => {
              //console.log(resp);

              this.messageService.add({
                severity: "success",
                summary: "Actualizado correctamente",
                detail: `Registro pesos actualizado`,
              });
              let observaciones: string = this.items.observaciones;
              if (this.file != null) {
                // this.UploadService.uploadFilesPesosPitufo(this.file, this.id)
                //   .toPromise()
                //   .then((archivo) => {
                //     console.log(" archivo ", archivo);
                //     this.messageService.add({
                //       severity: "info",
                //       summary: "Añadido correctamente",
                //       detail: "Archivo añadido correctamente",
                //     });
                //   })
                //   .catch((error) => {
                //     this.disableButton = true;
                //     console.log("error file", error);
                //   });
                this.fileUpload(this.file, this.id)
              }

              if (
                observaciones === null ||
                observaciones === undefined ||
                observaciones.length == 0
              ) {
              } else {
                this.emailService
                  .sendMessage(this.items, "PESOS PITUFO")
                  .toPromise()
                  .then((data) => {
                    //console.log('data', data);
                  })
                  .catch((error) => {
                    this.disableButton = true;
                    console.log("error message", error);
                    this.router.navigate(["dashboard/pesos"]);
                  });
              }
              this.router.navigate(["dashboard/pesos"]);
            },
            (error) => {
              console.log("Error", error);
            }
          );
      } else {
        this.pitufo.create(this.items).subscribe(
          (resp: any) => {
            // console.log("RESP",resp);
            this.id = resp.id;
            if (this.file != null) {
              // this.UploadService.uploadFilesPesosPitufo(this.file, id)
              //   .toPromise()
              //   .then((resp) => {})
              //   .catch((error) => {
              //     console.log("error file", error);
              //   });
              this.fileUpload(this.file, this.id)
            }
            this.messageService.add({
              severity: "success",
              summary: "Añadido correctamente",
              detail: `Registro pesos añadido`,
            });
            this.MyMachine = "";
            this.myClient = "";
            this.variedad = "";
            this.pesos = [];
            this.pesos_horas = [];
            this.myConfeccion = "";
            let observaciones: string = this.items.observaciones;

            console.log(observaciones);

            if (
              observaciones === null ||
              observaciones === undefined ||
              observaciones.length == 0
            ) {
            } else {
              this.emailService
                .sendMessage(this.items, "PESOS PITUFO")
                .toPromise()
                .then((data) => {
                  //console.log('data', data);
                })
                .catch((error) => {
                  console.log("error message", error);
                });
            }
            this.router.navigate(["dashboard/pesos"]);
          },
          (error) => {
            console.log("Error", error);
          }
        );
      }
    }
  }

  fechaActual() {
    let today = new Date();
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = yyyy + "-" + MM + "-" + DD;
    //console.log(myfecha);
    return myfecha;
  }

  fechaArreglada(fecha) {
    let today = new Date(fecha);
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = yyyy + "-" + MM + "-" + DD;
    return myfecha;
  }

  Regresar() {
    this.location.back();
  }

  consultar(id) {
    console.log(id);
  }

  delete(index) {
    // console.log(this.pesos);

    this.pesos.splice(index, 1);
    this.pesos_horas.splice(index, 1);
    this.pesos = [...this.pesos];
    this.pesos_horas = [...this.pesos_horas];
    // console.log(this.pesos);
  }

  fileUpload(file: File, id:string){
    this.UploadService.uploadFilesgeneric(file, id, this.database ,this.database,'etiqueta_archivo').toPromise()
    .then( res => {
      this.messageService.add({ severity: 'info', summary: 'Añadido correctamente', detail: 'Archivo añadido correctamente' });
      this.router.navigate(['dashboard/pesos'])
    });
  }
}

class info {
  fecha: string;
  hora: string;
  maquina: string;
  peso: String;

  constructor(fecha, hora, maquina, peso) {
    this.fecha = fecha;
    this.hora = hora;
    this.maquina = maquina;
    this.peso = peso;
  }
}
